import { http } from '@/plugins/http';
import API from '@/helpers/api';

export async function find() {
  return API('/mxmed/professionals').fetch();
}

export async function findProcedures(mxmedId) {
  const response = await http.get(`/mxmed/professionals/${mxmedId}/procedures`);
  return response.data;
}
